(function() {
'use strict';

angular.module('GorillaBoy.DocumentViewer')
.factory('FeedbackSyncService', ['FeedbackService', 'DocumentUtilities', 'AppConstants', FeedbackSyncService]);

function FeedbackSyncService(FeedbackService, DocumentUtilities, AppConstants) {
    var service = {};
    var feedbackTypes = AppConstants.FeedbackTypes;
    var documentState;
    service.initScope = function(documentStateVal) {
        documentState = documentStateVal;
    };
    service.unsetScope = function() {
        documentState = null;
    };
    FeedbackService.on(FeedbackService.events.AnnotationSynced, function feedbackServiceAnnotationSynced(event) {
        var DraftAnnotationId = event.DraftAnnotationId,
            Annotation = event.Annotation;

        var newIdMap = {};
        newIdMap[DraftAnnotationId] = Annotation.AnnotationId;
        documentState.documentViewerBridge.updateAnnotationIds(newIdMap);

        var feedbackObj = DocumentUtilities.getAnnotationObjectFromId(documentState.feedbackListMap, DraftAnnotationId);
        if (feedbackObj) {
            feedbackObj.AnnotationStatus = feedbackTypes.FEEDBACK_TYPE_DRAFT; //override the status from failed/retrying
            if (feedbackObj.ThreadId === feedbackObj.AnnotationId) {
                //This means it's a top level annotation
                feedbackObj.ThreadId = feedbackObj.AnnotationId = Annotation.AnnotationId;
            }
        }
    });

    FeedbackService.on(FeedbackService.events.AnnotationRetrying, function feedbackServiceAnnotationRetrying(event) {
        var DraftAnnotationId = event.DraftAnnotationId;
        var feedbackObj = DocumentUtilities.getAnnotationObjectFromId(documentState.feedbackListMap, DraftAnnotationId);
        if (feedbackObj) {
            feedbackObj.AnnotationStatus = feedbackTypes.FEEDBACK_TYPE_RETRY;
        }
    });

    FeedbackService.on(FeedbackService.events.AnnotationSyncFailed, function feedbackServiceAnnotationRetrying(event) {
        var DraftAnnotationId = event.DraftAnnotationId;
        var feedbackObj = DocumentUtilities.getAnnotationObjectFromId(documentState.feedbackListMap, DraftAnnotationId);
        if (feedbackObj) {
            feedbackObj.AnnotationStatus = feedbackTypes.FEEDBACK_TYPE_FAILED;
        }
    });

    FeedbackService.on(FeedbackService.events.CommentSynced, function feedbackServiceCommentSynced(event) {
        var DraftCommentId = event.DraftCommentId,
            Comment = event.Comment;

        var newIdMap = {};
        newIdMap[DraftCommentId] = Comment.CommentId;
        documentState.documentViewerBridge.updateAnnotationIds(newIdMap);

        var feedbackObj = DocumentUtilities.getCommentObjectFromId(documentState.feedbackListMap, DraftCommentId);
        if (feedbackObj) {
            feedbackObj.CommentStatus = feedbackTypes.FEEDBACK_TYPE_PUBLISHED;
            if (feedbackObj.ThreadId === feedbackObj.CommentId) {
                //This means it's a top level annotation
                feedbackObj.ThreadId = feedbackObj.CommentId = Comment.CommentId;
            }
        }
    });

    FeedbackService.on(FeedbackService.events.CommentRetrying, function feedbackServiceCommentRetrying(event) {
        var DraftCommentId = event.DraftCommentId;
        var feedbackObj = DocumentUtilities.getCommentObjectFromId(documentState.feedbackListMap, DraftCommentId);
        if (feedbackObj) {
            feedbackObj.CommentStatus = feedbackTypes.FEEDBACK_TYPE_RETRY;
        }
    });

    FeedbackService.on(FeedbackService.events.CommentSyncFailed, function feedbackServiceCommentRetrying(event) {
        var DraftCommentId = event.DraftCommentId;
        var feedbackObj = DocumentUtilities.getCommentObjectFromId(documentState.feedbackListMap, DraftCommentId);
        if (feedbackObj) {
            feedbackObj.CommentStatus = feedbackTypes.FEEDBACK_TYPE_FAILED;
        }
    });

    return service;
}
}());
